import { Button, SvgIconTypeMap } from "@mui/material"
import { OverridableComponent } from "@mui/material/OverridableComponent"
import React from "react"
import { customPalette } from "../../../theme"

interface IProps {
  label: string
  icon?: OverridableComponent<SvgIconTypeMap<unknown, "svg">>
  onClick?(): void
}

export function UnderlinedButton({ icon: Icon, label, onClick }: Readonly<IProps>): React.JSX.Element {
  return (
    <Button
      onClick={onClick}
      sx={{
        color: customPalette.black,
        textTransform: "none",
        "&:hover": { backgroundColor: "transparent", textDecoration: "underline", color: customPalette.mainGreen5 },
      }}>
      {Icon && <Icon />} {label}
    </Button>
  )
}
